// import { Currency } from 'typedefs';

export const SET_CURRENCY = '[currency] set currency';

export interface SetCurrency {
  type: typeof SET_CURRENCY;
  payload: { currency: string };
}
